// Note that characters must be unique and in ascending order of their character codes.

/** Decimal */
export const BASE10 = "0123456789";

/** Lowercase hex */
export const BASE16L = "0123456789abcdef";

/** Uppercase hex */
export const BASE16U = "0123456789ABCDEF";

/** Lowercase alphabets */
export const BASE26L = "abcdefghijklmnopqrstuvwxyz";

/** Uppercase alphabets */
export const BASE26U = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

/** Lowercase alphanumeric characters */
export const BASE36L = "0123456789abcdefghijklmnopqrstuvwxyz";

/** Uppercase alphanumeric characters */
export const BASE36U = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";

/** Alphabets */
export const BASE52 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

/** Alphanumeric characters */
export const BASE62 =
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

/** Characters used in Base64 URL */
export const BASE64URL =
  "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";

/** HTML safe chars */
export const BASE88 =
  "!#$%()*+,-./0123456789:;=?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[]^_`abcdefghijklmnopqrstuvwxyz{|}~";

/** All ASCII (excluding control chars and newlines) */
export const BASE95 =
  " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~";
